import { render, staticRenderFns } from "./BanksIntegrationsForm.vue?vue&type=template&id=5339238c&"
import script from "./BanksIntegrationsForm.vue?vue&type=script&lang=js&"
export * from "./BanksIntegrationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports